"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getLibraryVersion_1 = require("../../helpers/getLibraryVersion");
const command_1 = require("../../type/command");
const applyDeassignContent_1 = require("../applyDeassignContent");
function deassignChildContent(command, user, content, states, enrolments, rootEnrolment) {
    const childContents = [];
    const { id, creatorId, timeStamp } = command;
    const { userId } = user;
    const deassignContentCommand = {
        type: command_1.CommandType.DEASSIGN_CONTENT,
        creatorId,
        id,
        libraryVersion: getLibraryVersion_1.getLibraryVersion(),
        rootContentId: rootEnrolment.contentId,
        timeStamp,
        userId,
        deassignerId: creatorId
    };
    const deassignPayload = applyDeassignContent_1.applyDeassignContent(deassignContentCommand, user, content, childContents, states, enrolments);
    return deassignPayload;
}
exports.deassignChildContent = deassignChildContent;
//# sourceMappingURL=deassignChildContent.js.map